module.exports = __webpack_public_path__ + "static/media/fig_25.71db6fae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_25.jpg
// module id = 664
// module chunks = 0